import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin } from 'antd';
import moment from 'moment';
import { data3_2_1 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";
import Compared from "../../Compared";
const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        const naeData = ['outlets', 'seats', 'available', 'covers', 'revenue'];
        let toi_ranking = [];
        let ACI_ranking = [];
        let RGI_ranking = [];

        for (let i = 0; i < 5; i++) {
            data[5][naeData[i]] = naeData.reduce((a, b, index) => {
                a += numConvert(data[index][naeData[i]]);
                return a
            }, 0);
            toi_ranking.push({
                data: Number(data[i].toi || '0'),
                key: i
            });
            ACI_ranking.push({
                data: Number(data[i].ACI || '0'),
                key: i
            });
            RGI_ranking.push({
                data: Number(data[i].RGI || '0'),
                key: i
            });
            data[5][naeData[i]] = data[5][naeData[i]].toFixed(2);
        }

        for (let i = 0; i < data.length; i++) {
            // 上座率
            data[i].turn_over = (numConvert(data[i].available) == 0 ? 0 : numConvert(data[i].covers) / numConvert(data[i].available)).toFixed(3);
            // 人均消费
            data[i].AC = (numConvert(data[i].covers) == 0 ? 0 : numConvert(data[i].revenue) / numConvert(data[i].covers)).toFixed(2);
            // 可售餐位平均收入
            data[i].revpas = (numConvert(data[i].available) == 0 ? 0 : numConvert(data[i].revenue) / numConvert(data[i].available)).toFixed(2);
        };

        for (let i = 0; i < (data.length - 1); i++) {
            //  上座率指数
            data[i].toi = (numConvert(data[5].turn_over) == 0 ? 0 : numConvert(data[i].turn_over) / numConvert(data[5].turn_over)).toFixed(2);
            //   人均消费指数
            data[i].ACI = (numConvert(data[5].AC) == 0 ? 0 : numConvert(data[i].AC) / numConvert(data[5].AC)).toFixed(2);
            //   收益率指数
            data[i].RGI = (numConvert(data[5].revpas) == 0 ? 0 : numConvert(data[i].revpas) / numConvert(data[5].revpas)).toFixed(2);
        }


        // 计算排名
        toi_ranking.sort((a, b) => {
            return b.data - a.data
        });
        ACI_ranking.sort((a, b) => {
            return b.data - a.data
        });
        RGI_ranking.sort((a, b) => {
            return b.data - a.data
        });

        toi_ranking.forEach((x, i) => {
            data[x.key].toi_ranking = i + 1;
        });
        ACI_ranking.forEach((x, i) => {
            data[x.key].ACI_ranking = i + 1;
        });
        RGI_ranking.forEach((x, i) => {
            data[x.key].RGI_ranking = i + 1;
        });

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;
        // this.setState({
        //     data
        // });
        this.computeNum(data);
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);

        let d = await fetch(`/_3_1_1_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' });
        let data3_1 = await d.json();

        fetch(`/_3_3_2_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                data = x.data;
            }

            if (data3_1.data && data3_1.data.length > 0) {
                data = data.map((item, index) => {
                    if (index != data.length - 1) {
                        return ({ ...item, name: data3_1.data[index].name, name_code: data3_1.data[index].name_code })
                    }
                    return ({ ...item, })
                })
            }


            if (!data[0].id) {
                this.setState({
                    loading: false,
                    data,
                }, () => {
                    this.onSave();
                });
                return
            }

            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        };

        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));

        // if (!data.every(x => x.name)) {
        //     message.error('名称不能为空，请到3-1-1设置名称！');
        //     return
        // }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_3_3_2  ', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }



    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_3_2', 1.5, '6.22', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth - 2150 > 300 ? document.body.offsetWidth - 2150 : 300;
        const columns = [{
            title: 'Comp Set 竞争集群',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            fixed: "left",
            width,
            render: (text, record, index) => {
                return (
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div>No. of Meeting/Events<br />会议活动场次</div>,
            dataIndex: 'outlets',
            key: 'outlets',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['No. of Meeting/Events 会议活动场次'];
                if (index != 5) {
                    return (
                        <Compared data={{ index, key: 'outlets', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ''}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('outlets', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                } else {
                    return (
                        <Compared data={{ index, key: 'outlets', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                                {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }

            }
        }, {
            title: <div>Meeting/Banquet Space SQM<br />场地面积（平方米）</div>,
            dataIndex: 'seats',
            key: 'seats',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Meeting/Banquet Space SQM 场地面积（平方米）'];
                if (index != 5) {
                    return (
                        <Compared data={{ index, key: 'seats', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ''}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('seats', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                } else {
                    return (
                        <Compared data={{ index, key: 'seats', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                                {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }

            }
        }, {
            title: <div>Space Available SQM<br />可售总面积(平方米)</div>,
            dataIndex: 'available',
            key: 'available',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Space Available SQM 可售总面积(平方米)'];
                if (index != 5) {
                    return (
                        <Compared data={{ index, key: 'available', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ''}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('available', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                } else {
                    return (
                        <Compared data={{ index, key: 'available', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                                {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }

            }
        }, {
            title: <div>Sold Space<br />出售总面积 （平方米）</div>,
            dataIndex: 'covers',
            key: 'covers',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Sold Space 出售总面积 （平方米）'];
                if (index != 5) {
                    return (
                        <Compared data={{ index, key: 'covers', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ''}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('covers', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                } else {
                    return (
                        <Compared data={{ index, key: 'covers', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                                {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }

            }
        }, {
            title: <div>Space Occupancy<br /> 会议场地出租率</div>,
            dataIndex: 'turn_over',
            key: 'turn_over',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Space Occupancy 会议场地出租率'];
                return (
                    <Compared data={{ index, key: 'turn_over', title, sqlName: "_3_3_2", name: record.name, type: 'percent' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text) < 0 ? <span style={{ color: "red" }}>({(Math.abs(text) * 100).toFixed(1) + '%'})</span> : (text * 100).toFixed(1) + '%'}
                        </div>
                    </Compared>
                )
            }
        }, {
            title: <div>Total Catering Revenue<br /> 宴会活动总收入</div>,
            dataIndex: 'revenue',
            key: 'revenue',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Total Catering Revenue 宴会活动总收入'];
                if (index != 5) {
                    return (
                        <Compared data={{ index, key: 'revenue', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ''}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        this.onChange('revenue', value, index)
                                    }}

                                />
                            </div>
                        </Compared>
                    )
                } else {
                    return (
                        <Compared data={{ index, key: 'revenue', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                            <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                                {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            </div>
                        </Compared>
                    )
                }

            }
        }, {
            title: <div>S/C每平方米平均消费</div>,
            dataIndex: 'AC',
            key: 'AC',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['S/C每平方米平均消费'];
                return (
                    <Compared data={{ index, key: 'AC', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    </Compared>
                )

            }
        }, {
            title: <div>RevPASP <br /> 可售场地面积平均收入</div>,
            dataIndex: 'revpas',
            key: 'revpas',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['RevPASP 可售场地面积平均收入'];
                return (
                    <Compared data={{ index, key: 'revpas', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    </Compared>
                )

            }
        }, {
            title: <div>SPI 场地渗透率指数</div>,
            dataIndex: 'toi',
            key: 'toi',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['SPI 场地渗透率指数'];
                return (
                    <Compared data={{ index, key: 'toi', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    </Compared>
                )

            }
        }, {
            title: <div>Ranking 排名</div>,
            dataIndex: 'toi_ranking',
            key: 'toi_ranking',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Ranking 排名'];
                return (
                    <Compared data={{ index, key: 'toi_ranking', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    </Compared>
                )

            }
        }, {
            title: <div>SCI 平均消费指数</div>,
            dataIndex: 'ACI',
            key: 'ACI',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['SCI 平均消费指数'];
                return (<Compared data={{ index, key: 'ACI', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                    <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                </Compared>
                )

            }
        }, {
            title: <div>Ranking 排名</div>,
            dataIndex: 'ACI_ranking',
            key: 'ACI_ranking',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Ranking 排名'];
                return (
                    <Compared data={{ index, key: 'ACI_ranking', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    </Compared>
                )

            }
        }, {
            title: <div>RGI 收益率指数</div>,
            dataIndex: 'RGI',
            key: 'RGI',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['RGI 收益率指数'];
                return (
                    <Compared data={{ index, key: 'RGI', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    </Compared>
                )

            }
        }, {
            title: <div>Ranking 排名</div>,
            dataIndex: 'RGI_ranking',
            key: 'RGI_ranking',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = ['Ranking 排名'];
                return (
                    <Compared data={{ index, key: 'RGI_ranking', title, sqlName: "_3_3_2", name: record.name, type: 'number' }}>
                        <div className={`table-padding ${index == 5 ? 'table-color-footer' : ''}`}>
                            {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </div>
                    </Compared>
                )

            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1">
                    <Row className="title" id="table3_3_2" style={{ width: this.state.print ? 2450 : 'auto' }}>
                        <Row>6.2.2 YTD This  Year 年累计本年</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, 'YYYY-MM')}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            style={{ width: this.state.print ? 2400 : 'auto' }}
                            scroll={this.state.print ? {} : { x: 2400 }}
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_3_3">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/3.0/3-3/3-3-2.js